import {Clausepart} from "common/types/document";

interface ClauseData {
  clause_reference?: string;
  clause_reference_general?: string;
  clause_text?: string;
  reference?: string;
}

export default function matchDocumentClausepart(
  clauseData: ClauseData,
  documentClauseparts: Clausepart[],
): Clausepart | null {
  const clauseRefMatch =
    getClauseRefMatch(clauseData.clause_reference, documentClauseparts) ??
    getClauseRefMatch(clauseData.clause_reference_general, documentClauseparts);

  const clauseparts = clauseRefMatch
    ? documentClauseparts.filter(
        ({clause_id}) => clause_id === clauseRefMatch.clause_id,
      )
    : documentClauseparts;

  const clauseText = clauseData.clause_text;
  if (clauseText === undefined) {
    return clauseRefMatch ?? null;
  }

  const fullTextMatch = getFullClauseTextMatch(clauseText, clauseparts);

  if (fullTextMatch) {
    return fullTextMatch;
  }

  if (clauseText.split(" ").length < 5) {
    // Too short for substring match
    return clauseRefMatch ?? null;
  }

  const partialTextMatch = getPartialClauseTextMatch(clauseText, clauseparts);
  return partialTextMatch ?? clauseRefMatch ?? null;
}

function getPartialClauseTextMatch(
  clauseText: string,
  clauseparts,
): Clausepart | undefined {
  return clauseparts.find(({text}) => text.includes(clauseText));
}

function getFullClauseTextMatch(
  clauseText: string,
  clauseparts,
): Clausepart | undefined {
  return clauseparts.find(({text}) => text === clauseText);
}

function getClauseRefMatch(
  clauseReference: string | undefined,
  clauseparts: Clausepart[],
): Clausepart | undefined {
  if (clauseReference === undefined) {
    return undefined;
  }
  return clauseparts.find(
    ({clause_reference, reference}) =>
      clauseReference === clause_reference || clauseReference === reference,
  );
}
